import { createFileRoute } from "@tanstack/react-router";

import { ORGANIZATION_QUERY } from "@/features/organizations/graphql/organization-query";
import { Organization } from "@/features/organizations/organization";

export const Route = createFileRoute("/_authenticated/organizations/$id")({
  component: Organization,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(ORGANIZATION_QUERY, { id: params.id }).toPromise();
    }
  },
});
